import { callApi } from "./fetchTools";
import { HTTP_METHOD_GET, HTTP_METHOD_POST } from "../utils/constant";
import apis from "../common/apis";
import { IBanner } from "../models/bannerModel";
import IProvince from "../models/provinceModel";
import IDistrict from "../models/districtModel";
import IWard from "../models/wardModel";

export const getDistricts = (provinceId: any) => {
  return callApi<IDistrict[]>(
    HTTP_METHOD_GET,
    `${apis.public_districts}${provinceId}`,
    null
  );
};

export const getWards = (districtId: any) => {
  return callApi<IWard[]>(
    HTTP_METHOD_GET,
    `${apis.public_wards}${districtId}`,
    null
  );
};

export default {
  getBanners: (type: string, query: any) => {
    return callApi<IBanner[]>(HTTP_METHOD_GET, `${apis.banner}${type}`, query);
  },
  getProvinces: () => {
    return callApi<IProvince[]>(
      HTTP_METHOD_GET,
      `${apis.public_provinces}1`,
      null
    );
  },
  getDistricts,
  getWards,
  getStores: (query: any) => {
    return callApi<any>(HTTP_METHOD_POST, apis.public_store, query);
  },
  getDistrictStore: () => {
    return callApi<any>(HTTP_METHOD_GET, apis.public_district_store, null);
  },
  getStoresWithFilters: (query: any) => {
    return callApi<any>(HTTP_METHOD_POST, apis.public_filter_store, query);
  },
  getContacts: () => {
    return callApi<any>(HTTP_METHOD_GET, apis.contact, null);
  },
  getStore: (id: string) => {
    return callApi<any>(HTTP_METHOD_GET, `${apis.public_store}${id}`, null);
  },
};
